"use client";
import React, { useEffect, useState } from "react";
import styles from "./Navbar.module.scss";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import { checkNotAdmin, combineClasses } from "utils/utils";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "components/UI/Button/Button";

const Menu = ({ tabs }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isLogin = localStorage?.getItem("accessToken");

  const handleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const root = document.documentElement;

    if (isOpen) {
      root.classList.add("overflow-hidden");
    } else {
      root.classList.remove("overflow-hidden");
    }

    return () => {
      root.classList.remove("overflow-hidden");
    };
  }, [isOpen]);

  return (
    <>
      <button onClick={handleMenu} className={styles.hamburger}>
        {isOpen ? <RxCross1 className={styles.cross} /> : <RxHamburgerMenu />}
      </button>

      <div
        className={combineClasses(styles.menubar, isOpen && styles.openMenubar)}
      >
        <ul className={styles.menuList}>
          {tabs.map((tab) => (
            <li key={tab.name}>
              <a
                className={combineClasses(
                  styles.tab,
                  pathname === tab.href && styles.active
                )}
                href={tab.href}
              >
                {tab.name}
              </a>
            </li>
          ))}
          {isLogin && <li key={'feed'}>
            <a
              className={combineClasses(
                styles.tab,
                pathname === '/feed' && styles.active
              )}
              href={'/feed'}
            >
              {'Feed'}
            </a>
          </li>}
        </ul>
        {!isLogin && <div className={styles.btns}>
          <Button
            onClick={() => navigate("/signin")}
            className={styles.btn}
            variant="outlined"
          >
            Log In
          </Button>
          <Button
            onClick={() => navigate("/signup")}
            className={styles.btn}
            variant="filled"
          >
            Sign Up
          </Button>
        </div>}
      </div>
    </>
  );
};

export default Menu;
